import { render, staticRenderFns } from "./DetailProdotto.vue?vue&type=template&id=29ff024e&"
import script from "./DetailProdotto.vue?vue&type=script&lang=js&"
export * from "./DetailProdotto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports